import { ValidationError } from '@/core/utils/validation';
export function logValidationErrors(message, ex) {
    if (!(ex instanceof ValidationError))
        return;
    // TODO: (later) add error log to backend.
    console.error(`${message} validation errors: `, ex.errors);
}
